var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("el-backtop", {
    attrs: {
      bottom: 100
    }
  }, [_c("div", {
    staticStyle: {
      height: "100%",
      width: "100%",
      "background-color": "var(--el-bg-color-overlay)",
      "box-shadow": "var(--el-box-shadow-lighter)",
      "text-align": "center",
      "line-height": "40px",
      color: "#1989fa",
      display: "flex",
      "align-items": "center",
      "justify-content": "center",
      "border-radius": "50%"
    }
  }, [_c("i", {
    staticClass: "el-icon-arrow-up",
    staticStyle: {
      "font-size": "20px"
    }
  })])]), _c("div", {
    staticClass: "filter-header",
    staticStyle: {
      display: "flex",
      "justify-content": "space-between",
      "margin-bottom": "10px"
    }
  }, [_c("el-button", {
    attrs: {
      type: "primary",
      size: "mini"
    },
    on: {
      click: function ($event) {
        _vm.showFilters = !_vm.showFilters;
      }
    }
  }, [_vm._v(" Filters & More "), _c("i", {
    class: _vm.showFilters ? "el-icon-arrow-up" : "el-icon-arrow-down",
    staticStyle: {
      "margin-left": "5px"
    }
  })])], 1), _vm.showFilters ? _c("div", {
    staticClass: "filter-container"
  }, [_c("el-select", {
    attrs: {
      filterable: "",
      clearable: "",
      name: "branchId",
      placeholder: "Select Branch"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.branchId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "branchId", $$v);
      },
      expression: "listQuery.branchId"
    }
  }, _vm._l(_vm.branchList, function (branch) {
    return _c("el-option", {
      key: branch.id,
      attrs: {
        label: branch.code,
        value: branch.id
      }
    });
  }), 1), !_vm.isSalesExecutiveAdmin() ? _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      filterable: "",
      clearable: "",
      placeholder: "Select Branch Manager"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery["mappedAdmin.id"],
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "mappedAdmin.id", $$v);
      },
      expression: "listQuery['mappedAdmin.id']"
    }
  }, _vm._l(_vm.salesExecutiveAdmins, function (salesExecutive) {
    return _c("el-option", {
      key: salesExecutive.id,
      attrs: {
        label: salesExecutive.fullName,
        value: salesExecutive.id
      }
    });
  }), 1) : _vm._e(), !_vm.isZonalManagerAdmin() ? _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      filterable: "",
      clearable: "",
      placeholder: "Select Zonal Manager"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery["zonalAdmin.id"],
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "zonalAdmin.id", $$v);
      },
      expression: "listQuery['zonalAdmin.id']"
    }
  }, _vm._l(_vm.zonalManagerAdmins, function (zonalAdmin) {
    return _c("el-option", {
      key: zonalAdmin.id,
      attrs: {
        label: zonalAdmin.fullName,
        value: zonalAdmin.id
      }
    });
  }), 1) : _vm._e(), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      filterable: "",
      clearable: "",
      remote: "",
      loading: _vm.dealerListLoading,
      "loading-text": "fetching dealers..",
      "remote-method": _vm.getDealerList,
      placeholder: _vm.$t("dealersDispatch.dealer")
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.dealerId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "dealerId", $$v);
      },
      expression: "listQuery.dealerId"
    }
  }, _vm._l(_vm.dealerList, function (dealer) {
    return _c("el-option", {
      key: dealer.id,
      attrs: {
        label: dealer.name,
        value: dealer.id
      }
    }, [_c("span", {
      staticStyle: {
        float: "left",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(dealer.name) + " - " + _vm._s(dealer.code))]), _c("span", {
      staticStyle: {
        float: "right",
        color: "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v("   | ID: " + _vm._s(dealer.id))])]);
  }), 1), !_vm.isAgent ? _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      filterable: "",
      clearable: "",
      placeholder: _vm.$t("dealersDispatch.agent")
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.agentId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "agentId", $$v);
      },
      expression: "listQuery.agentId"
    }
  }, _vm._l(_vm.agentList, function (agent) {
    return _c("el-option", {
      key: agent.id,
      attrs: {
        label: agent.name,
        value: agent.id
      }
    });
  }), 1) : _vm._e(), !_vm.isAgent ? _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      disabled: !_vm.listQuery.agentId,
      filterable: "",
      clearable: "",
      placeholder: "Select Sales Executive Agent"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.assignedAgentId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "assignedAgentId", $$v);
      },
      expression: "listQuery.assignedAgentId"
    }
  }, _vm._l(_vm.agentUserList, function (agentUser) {
    return _c("el-option", {
      key: agentUser.id,
      attrs: {
        label: agentUser.fullName,
        value: agentUser.id
      }
    });
  }), 1) : _vm._e(), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      filterable: "",
      clearable: "",
      placeholder: "States"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.stateId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "stateId", $$v);
      },
      expression: "listQuery.stateId"
    }
  }, _vm._l(_vm.stateList, function (state) {
    return _c("el-option", {
      key: state.id,
      attrs: {
        label: state.name,
        value: state.id
      }
    }, [_c("span", {
      staticStyle: {
        float: "left",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(state.name))])]);
  }), 1), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      filterable: "",
      clearable: "",
      remote: "",
      loading: _vm.cityListLoading,
      "loading-text": "fetching cities..",
      "remote-method": _vm.getCityList,
      placeholder: "Search City"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.cityName,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "cityName", $$v);
      },
      expression: "listQuery.cityName"
    }
  }, _vm._l(_vm.cityList, function (city) {
    return _c("el-option", {
      key: city.id,
      attrs: {
        label: city.name,
        value: city.name
      }
    }, [_c("span", {
      staticStyle: {
        float: "left",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(city.name))])]);
  }), 1), _c("el-select", {
    attrs: {
      placeholder: "Select Status",
      clearable: ""
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.status,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "status", $$v);
      },
      expression: "listQuery.status"
    }
  }, _vm._l(_vm.statusOptions, function (item) {
    return _c("el-option", {
      key: item.key,
      attrs: {
        label: item.label,
        value: item.key
      }
    });
  }), 1), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      clearable: "",
      placeholder: "Collectible"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.isCollectible,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "isCollectible", $$v);
      },
      expression: "listQuery.isCollectible"
    }
  }, [_c("el-option", {
    attrs: {
      label: "Collectible",
      value: true
    }
  }), _c("el-option", {
    attrs: {
      label: "Non-Collectible",
      value: false
    }
  })], 1), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "primary",
      size: "mini",
      icon: "el-icon-document"
    },
    on: {
      click: _vm.handleExcelDownload
    }
  }, [_vm._v(" Export as Excel ")]), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "danger",
      size: "mini",
      icon: "el-icon-document"
    },
    on: {
      click: _vm.handleClearCache
    }
  }, [_vm._v(" Clear Cache ")]), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "primary",
      icon: "el-icon-search",
      size: "mini"
    },
    on: {
      click: _vm.handleFilter
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("table.search")) + " ")])], 1) : _vm._e(), _vm._isAdminRoles() ? _c("el-checkbox", {
    on: {
      change: _vm.onCheckboxChange
    },
    model: {
      value: _vm.listQuery.excludeBranches,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "excludeBranches", $$v);
      },
      expression: "listQuery.excludeBranches"
    }
  }, [_vm._v(" Uncheck to include branch ")]) : _vm._e(), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.listLoading,
      expression: "listLoading"
    }],
    key: _vm.tableKey,
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.list,
      border: "",
      fit: "",
      "highlight-current-row": "",
      "show-summary": "",
      "summary-method": _vm.getSummaries
    },
    on: {
      "sort-change": _vm.sortChange
    }
  }, [_c("el-table-column", {
    attrs: {
      width: "220",
      align: "center",
      label: "Dealer Name",
      prop: "dealerName",
      fixed: "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("b", [_vm._v(_vm._s(scope.row.dealerName))]), _vm.checkCreditStatus(scope.row) || scope.row.status === "Blocked" ? _c("el-tooltip", {
          staticClass: "item",
          attrs: {
            effect: "dark",
            content: _vm.getTooltipMessage(scope.row),
            placement: "top",
            "popper-style": {
              color: _vm.getLockColor(scope.row)
            }
          }
        }, [_c("i", {
          staticClass: "el-icon-lock",
          style: {
            fontSize: "15px",
            marginLeft: "5px",
            color: _vm.getLockColor(scope.row)
          }
        })]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "120",
      align: "center",
      label: "City",
      prop: "city"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.city) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "130",
      align: "center",
      label: "Credit Limit",
      prop: "creditLimit"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("inr", {
          attrs: {
            number: Math.round(scope.row.creditLimit)
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "130",
      align: "center",
      label: "Total Outstanding",
      prop: "totalOutstanding"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("inr", {
          attrs: {
            number: Math.round(scope.row.totalOutstanding)
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "130",
      align: "center",
      label: "Credit Available"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("inr", {
          attrs: {
            number: Math.round(scope.row.creditLimit - scope.row.totalOutstanding)
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "150",
      align: "center",
      label: "Outstanding(0-30 days)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("inr", {
          attrs: {
            number: Math.round(_vm.getPendingAmountForPeriod(scope.row, "0 - 30 days"))
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "150",
      align: "center",
      label: "Outstanding(31-60 days)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("inr", {
          attrs: {
            number: Math.round(_vm.getPendingAmountForPeriod(scope.row, "31 - 60 days"))
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "165",
      align: "center",
      label: "Outstanding(61-90 days)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("inr", {
          attrs: {
            number: Math.round(_vm.getPendingAmountForPeriod(scope.row, "61 - 90 days"))
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "165",
      align: "center",
      label: "Outstanding(91-120 days)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("inr", {
          attrs: {
            number: Math.round(_vm.getPendingAmountForPeriod(scope.row, "91 - 120 days"))
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "165",
      align: "center",
      label: "Outstanding(121-150 days)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("inr", {
          attrs: {
            number: Math.round(_vm.getPendingAmountForPeriod(scope.row, "121 - 150 days"))
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "150",
      align: "center",
      label: "Outstanding(150+ days)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("inr", {
          attrs: {
            number: Math.round(_vm.getPendingAmountForPeriod(scope.row, "150+ days"))
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      align: "center",
      label: "Actions",
      width: "50",
      fixed: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-tooltip", {
          staticClass: "item",
          attrs: {
            effect: "dark",
            content: "Click to Download Ageing Report",
            placement: "top"
          }
        }, [_c("el-button", {
          attrs: {
            size: "mini",
            type: "primary",
            icon: "el-icon-download"
          },
          on: {
            click: function ($event) {
              return _vm.downloadAgeingReportPdf(scope.row);
            }
          }
        })], 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "200px",
      align: "center",
      label: "Branch Manager"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(_vm.getAdminByRole(scope.row.mappedAdmins, "Branch Manager")) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "200px",
      align: "center",
      label: "Zonal Manager"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(_vm.getAdminByRole(scope.row.mappedAdmins, "Zonal Manager")) + " ")];
      }
    }])
  })], 1), _c("pagination", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.total > 0,
      expression: "total > 0"
    }],
    attrs: {
      total: _vm.total,
      page: _vm.listQuery.page,
      limit: _vm.listQuery.limit
    },
    on: {
      "update:page": function ($event) {
        return _vm.$set(_vm.listQuery, "page", $event);
      },
      "update:limit": function ($event) {
        return _vm.$set(_vm.listQuery, "limit", $event);
      },
      pagination: _vm.getList
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };